import { getShadowAccountColumns } from './shadow.account.columns.configuration'
import { getShadowNetworkColumns } from './known.network.columns.configuration'
import type { ShadowAccountColumnsOptions } from '../models'
import { ShadowType } from '@src/endpoints/services/graphQueryMgr.service'
import type {
  ShadowAccess,
  ShadowNetworkItem,
  ShadowAccountItem
} from '@src/redux/reducers/external.lists/default.state'
import type { FilterOptions } from '@src/components/data.grid/models'
export * from './shadow.access.tabs'

export const filterOptions: FilterOptions = {
  hasSearchBar: true,
  placeholder: 'Search'
}

interface Sort<T> {
  id: keyof T
  desc: boolean
}

const defaultSorted: Sort<ShadowAccountItem>[] = [
  { id: 'resources_available', desc: true },
  { id: 'account_id', desc: false }
]

export const getShadowAccessGridConfig = (
  options: ShadowAccountColumnsOptions
) => {
  const { selectedTab, lists } = options || {}
  const {
    unknown_account = [],
    known_account = [],
    shadow_network = []
  } = (lists || {}) as ShadowAccess
  switch (selectedTab) {
    case ShadowType.SHADOW_UNKNOWN_ACCOUNT:
      return {
        data: unknown_account || [],
        columns: getShadowAccountColumns(options) || [],
        defaultSorted
      }
    case ShadowType.SHADOW_KNOWN_ACCOUNT:
      return {
        data: known_account || [],
        columns: getShadowAccountColumns(options) || [],
        defaultSorted
      }

    case ShadowType.SHADOW_KNOWN_NETWORK:
      return {
        data: shadow_network || [],
        columns: getShadowNetworkColumns(options) || [],
        defaultSorted: [{ id: 'network_ip' }] as Sort<ShadowNetworkItem>[]
      }

    default:
      return {
        data: [],
        columns: []
      }
  }
}
